export const PaymentDetailsConstants = {
    SUCCESS_ALERT_MESSAGE: 'Payment details have been successfully saved.',
} as const;
